export const SPACE_CHANGED = "SPACE_CHANGED";
